// src/hooks/useUsers.js
import { useEffect, useState } from "react";
import { subscribeUsersByRole, subscribePendingCaptains } from "../services/userService";

function useSubscription(fn, ...args) {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);
  const key = args.join("|");

  useEffect(() => {
    setLoading(true);
    const unsub = fn(...args,
      d => { setData(d); setLoading(false); },
      e => { console.error(e); setLoading(false); }
    );
    return () => unsub && unsub();
  }, [key]);

  return { data, loading };
}

export const useCaptains        = () => useSubscription(subscribeUsersByRole, "captain");
export const useClients         = () => useSubscription(subscribeUsersByRole, "client");
export const usePendingCaptains = () => useSubscription(subscribePendingCaptains);
